// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3QEYa","productName":"Table_productName__uf15B"};